/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_SEASONS = '[Tournament] Get Seasons',
  GET_SEASONS_SUCCESS = '[Tournament] Get Seasons Success',
  GET_SEASONS_FAILED = '[Tournament] Get Seasons Failed',

  CREATE_SEASON = '[Tournament] Create Season',
  CREATE_SEASON_SUCCESS = '[Tournament] Create Season Success',
  CREATE_SEASON_FAILED = '[Tournament] Create Season Failed',

  GET_LEAGUES = '[Tournament] Get Leagues',
  GET_LEAGUES_SUCCESS = '[Tournament] Get Leagues Success',
  GET_LEAGUES_FAILED = '[Tournament] Get Leagues Failed',

  CREATE_SEASON_LEAGUE = '[Tournament] Create Season League',
  CREATE_SEASON_LEAGUE_SUCCESS = '[Tournament] Create Season League Success',
  CREATE_SEASON_LEAGUE_FAILED = '[Tournament] Create Season League Failed',

  GET_LEAGUE_DETAILS = '[Tournament] Get League Details',
  GET_LEAGUE_DETAILS_SUCCESS = '[Tournament] Get League Details Success',
  GET_LEAGUE_DETAILS_FAILED = '[Tournament] Get League Details Failed',

  GET_LEAGUE_GAMES = '[Tournament] Get League Games',
  GET_LEAGUE_GAMES_SUCCESS = '[Tournament] Get League Games Success',
  GET_LEAGUE_GAMES_FAILED = '[Tournament] Get League Games Failed',

  GET_LEAGUE_PLAYERS = '[Tournament] Get League Players',
  GET_LEAGUE_PLAYERS_SUCCESS = '[Tournament] Get League Players Success',
  GET_LEAGUE_PLAYERS_FAILED = '[Tournament] Get League Players Failed',

  CREATE_LEAGUE_PLAYERS = '[Tournament] Create League Players',
  CREATE_LEAGUE_PLAYERS_SUCCESS = '[Tournament] Create League Players Success',
  CREATE_LEAGUE_PLAYERS_FAILED = '[Tournament] Create League Players Failed',

  ASSIGN_SEEDS = '[Tournament] Assign Seeds',
  ASSIGN_SEEDS_SUCCESS = '[Tournament] Assign Seeds Success',
  ASSIGN_SEEDS_FAILED = '[Tournament] Assign Seeds Failed',

  GENERATE_MATCHUPS = '[Tournament] Generate Matchups',
  GENERATE_MATCHUPS_SUCCESS = '[Tournament] Generate Matchups Success',
  GENERATE_MATCHUPS_FAILED = '[Tournament] Generate Matchups Failed',

  START_LEAGUE_TOURNAMENT = '[Tournament] Start League Tournament',
  START_LEAGUE_TOURNAMENT_SUCCESS = '[Tournament] Start League Tournament Success',
  START_LEAGUE_TOURNAMENT_FAILED = '[Tournament] Start League Tournament Failed',

  GENERATE_NEXT_ROUND = '[Tournament] Generate Next Round',
  GENERATE_NEXT_ROUND_SUCCESS = '[Tournament] Generate Next Round Success',
  GENERATE_NEXT_ROUND_FAILED = '[Tournament] Generate Next Round Failed',

  COMPLETE_LEAGUE_TOURNAMENT = '[Tournament] Complete League Tournament',
  COMPLETE_LEAGUE_TOURNAMENT_SUCCESS = '[Tournament] Complete League Tournament Success',
  COMPLETE_LEAGUE_TOURNAMENT_FAILED = '[Tournament] Complete League Tournament Failed',
}

export const getSeasons = createAction(
  ActionTypes.GET_SEASONS
);

export const getSeasonsSuccess = createAction(
	ActionTypes.GET_SEASONS_SUCCESS,
  props<{ data: any }>()
);

export const getSeasonsFailed = createAction(
  ActionTypes.GET_SEASONS_FAILED,
  props<{ data: any }>()
);

export const createSeason = createAction(
  ActionTypes.CREATE_SEASON,
  props<{ data: any }>()
);

export const createSeasonSuccess = createAction(
	ActionTypes.CREATE_SEASON_SUCCESS,
  props<{ data: any }>()
);

export const createSeasonFailed = createAction(
  ActionTypes.CREATE_SEASON_FAILED,
  props<{ data: any }>()
);

export const getLeagues = createAction(
  ActionTypes.GET_LEAGUES,
  props<{ data: any, redirect: Boolean }>()
);

export const getLeaguesSuccess = createAction(
	ActionTypes.GET_LEAGUES_SUCCESS,
  props<{ data: any }>()
);

export const getLeaguesFailed = createAction(
  ActionTypes.GET_LEAGUES_FAILED,
  props<{ data: any }>()
);

export const createSeasonLeague = createAction(
  ActionTypes.CREATE_SEASON_LEAGUE,
  props<{ data: any }>()
);

export const createSeasonLeagueSuccess = createAction(
	ActionTypes.CREATE_SEASON_LEAGUE_SUCCESS,
  props<{ data: any }>()
);

export const createSeasonLeagueFailed = createAction(
  ActionTypes.CREATE_SEASON_LEAGUE_FAILED,
  props<{ data: any }>()
);

export const getLeagueDetails = createAction(
  ActionTypes.GET_LEAGUE_DETAILS,
  props<{ data: any }>()
);

export const getLeagueDetailsSuccess = createAction(
	ActionTypes.GET_LEAGUE_DETAILS_SUCCESS,
  props<{ data: any }>()
);

export const getLeagueDetailsFailed = createAction(
  ActionTypes.GET_LEAGUE_DETAILS_FAILED,
  props<{ data: any }>()
);

export const getLeagueGames = createAction(
  ActionTypes.GET_LEAGUE_GAMES,
  props<{ data: any, league: any }>()
);

export const getLeagueGamesSuccess = createAction(
	ActionTypes.GET_LEAGUE_GAMES_SUCCESS,
  props<{ data: any, league: any }>()
);

export const getLeagueGamesFailed = createAction(
  ActionTypes.GET_LEAGUE_GAMES_FAILED,
  props<{ data: any }>()
);

export const getLeaguePlayers = createAction(
  ActionTypes.GET_LEAGUE_PLAYERS,
  props<{ data: any, league: any, redirect: Boolean }>()
);

export const getLeaguePlayersSuccess = createAction(
	ActionTypes.GET_LEAGUE_PLAYERS_SUCCESS,
  props<{ data: any, league: any, redirect: Boolean }>()
);

export const getLeaguePlayersFailed = createAction(
  ActionTypes.GET_LEAGUE_PLAYERS_FAILED,
  props<{ data: any }>()
);

export const createLeaguePlayers = createAction(
  ActionTypes.CREATE_LEAGUE_PLAYERS,
  props<{ data: any, league: any }>()
);

export const createLeaguePlayersSuccess = createAction(
	ActionTypes.CREATE_LEAGUE_PLAYERS_SUCCESS,
  props<{ data: any, league: any }>()
);

export const createLeaguePlayersFailed = createAction(
  ActionTypes.CREATE_LEAGUE_PLAYERS_FAILED,
  props<{ data: any }>()
);

export const assignSeeds = createAction(
  ActionTypes.ASSIGN_SEEDS,
  props<{ data: any, seasonId: any }>()
);

export const assignSeedsSuccess = createAction(
	ActionTypes.ASSIGN_SEEDS_SUCCESS,
  props<{ seasonId: any }>()
);

export const assignSeedsFailed = createAction(
  ActionTypes.ASSIGN_SEEDS_FAILED,
  props<{ data: any }>()
);

export const generateMatchups = createAction(
  ActionTypes.GENERATE_MATCHUPS,
  props<{ data: any, seasonId: any }>()
);

export const generateMatchupsSuccess = createAction(
	ActionTypes.GENERATE_MATCHUPS_SUCCESS,
  props<{ seasonId: any }>()
);

export const generateMatchupsFailed = createAction(
  ActionTypes.GENERATE_MATCHUPS_FAILED,
  props<{ data: any }>()
);

export const startLeagueTournament = createAction(
  ActionTypes.START_LEAGUE_TOURNAMENT,
  props<{ data: any, seasonId: any }>()
);

export const startLeagueTournamentSuccess = createAction(
	ActionTypes.START_LEAGUE_TOURNAMENT_SUCCESS,
  props<{ seasonId: any }>()
);

export const startLeagueTournamentFailed = createAction(
  ActionTypes.START_LEAGUE_TOURNAMENT_FAILED,
  props<{ data: any }>()
);

export const generateNextRound = createAction(
  ActionTypes.GENERATE_NEXT_ROUND,
  props<{ data: any, seasonId: any }>()
);

export const generateNextRoundSuccess = createAction(
	ActionTypes.GENERATE_NEXT_ROUND_SUCCESS,
  props<{ seasonId: any }>()
);

export const generateNextRoundFailed = createAction(
  ActionTypes.GENERATE_NEXT_ROUND_FAILED,
  props<{ data: any }>()
);

export const completeLeagueTournament = createAction(
  ActionTypes.COMPLETE_LEAGUE_TOURNAMENT,
  props<{ data: any, seasonId: any }>()
);

export const completeLeagueTournamentSuccess = createAction(
	ActionTypes.COMPLETE_LEAGUE_TOURNAMENT_SUCCESS,
  props<{ seasonId: any }>()
);

export const completeLeagueTournamentFailed = createAction(
  ActionTypes.COMPLETE_LEAGUE_TOURNAMENT_FAILED,
  props<{ data: any }>()
);